/**
 * API configuration — the single place the FE learns where the backend is and
 * who it is. Added for the FE↔BE integration.
 *
 * Values come from webpack DefinePlugin globals (see web/webpack.config.js). We
 * read them behind `typeof` guards so the module never throws if a global is
 * absent (e.g. under Jest, which doesn't run DefinePlugin) — it falls back to
 * local-dev defaults instead.
 */

// Backend origin. BE runs on :4000; the FE dev server owns :3000.
export const API_BASE: string =
  typeof __SK_BRIDGE_API_BASE__ !== 'undefined' ? __SK_BRIDGE_API_BASE__ : 'http://localhost:4000';

// All bridge endpoints live under this prefix (see sk-bridge-api app.ts).
export const API_PREFIX = '/api/bridge/v1';

// Dev tenant id sent as x-tenant-id. MUST be a valid v4 UUID — the BE validates
// it with Zod .uuid() and 401s on non-RFC values. This is the one place to
// change the local tenant; later, real Platform JWT auth replaces this single
// header (see authHeaders in client.ts).
export const DEV_TENANT_ID: string =
  typeof __SK_BRIDGE_TENANT_ID__ !== 'undefined'
    ? __SK_BRIDGE_TENANT_ID__
    : '54253f88-94dc-42d5-9d70-bdf4fba26634';

// Master switch: when false, the app stays entirely on its mock seed data.
// Lets us wire one feature at a time and fall back safely. Defaults to true in
// the browser bundle (DefinePlugin sets '1'); defaults to false elsewhere
// (e.g. tests) so unit tests never accidentally hit a live server.
export const USE_BACKEND: boolean =
  typeof __SK_BRIDGE_USE_BACKEND__ !== 'undefined' ? __SK_BRIDGE_USE_BACKEND__ === '1' : false;

// Platform origin — where signup / login / verify live. Bridge owns no auth UI:
// an unauthenticated visitor is sent here and returns with the session cookie
// set (same as the nexus/salon consoles).
export const PLATFORM_BASE: string =
  typeof __SK_PLATFORM_BASE__ !== 'undefined' ? __SK_PLATFORM_BASE__ : 'http://localhost:3000';

// The platform's auth app (the screens a human sees), distinct from its API.
export const PLATFORM_AUTH_APP: string =
  typeof __SK_PLATFORM_AUTH_APP__ !== 'undefined' ? __SK_PLATFORM_AUTH_APP__ : 'http://localhost:3009';

// When on, the session is the platform's httpOnly cookie and an unauthenticated
// visitor is redirected to the platform auth app. When off, the FE sends
// DEV_TENANT_ID for a bridge API running with AUTH_DEV_BYPASS=true.
export const USE_PLATFORM_AUTH: boolean =
  typeof __SK_BRIDGE_PLATFORM_AUTH__ !== 'undefined' ? __SK_BRIDGE_PLATFORM_AUTH__ === '1' : false;
